import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Subscription } from '../types/subscriptions';
import { revokeLicense } from '../store/licenses.store';
import SubscriptionsTable from '../components/SubscriptionsTable';
import { t } from '@moovly/i18n';
import useConfirmationModal from '../../../modals/useConfirmationModal';
import useSubscriptions from '../hooks/useSubscriptions';
import { useModal } from '@moovly/ui';
import AssignLicenseModal from '../modals/AssignLicenseModal';

const SubscriptionsContainer = () => {
  const dispatch = useDispatch<any>();
  const { subscriptions, isLoading } = useSubscriptions();
  const {
    isOpen: assignLicenseModalOpen,
    openModal: openAssignLicenseModal,
    modalProps: subscriptionAssign,
    ...otherAssignLicenseModalProps
  } = useModal();

  const { ConfirmationModal, openConfirmationModal } = useConfirmationModal();
  const handleAssign = React.useCallback(
    (license: Subscription) => openAssignLicenseModal(license),
    [openAssignLicenseModal]
  );
  const handleRevoke = React.useCallback(
    (license: Subscription) =>
      openConfirmationModal(
        {
          title: t('revokeModal.title'),
          description: t('revokeModal.description'),
        },
        () =>
          dispatch(
            revokeLicense({
              licenseId: license.id,
              contractId: license.contract.id,
            })
          )
      ),
    [dispatch, openConfirmationModal]
  );

  return (
    <>
      <SubscriptionsTable
        subscriptions={subscriptions}
        loading={isLoading}
        onAssign={handleAssign}
        onRevoke={handleRevoke}
      />
      <ConfirmationModal />
      {assignLicenseModalOpen && (
        <AssignLicenseModal subscription={subscriptionAssign} {...otherAssignLicenseModalProps} />
      )}
    </>
  );
};

export default SubscriptionsContainer;
